import PropTypes from 'prop-types'
import { ColumnChart } from '../../../common/components/charts/ColumnChart'
import { EVOLUCION_DENUNCIAS_CHART } from '../../../common/constants/charts'

const CHART_HEIGHT = 430

const LoadingState = () => (
  <div className="relative min-h-[26.875rem]">
    <div className="h-[26.875rem] rounded bg-tertiary-80/20 animate-pulse" />
    <div className="absolute inset-0 flex items-center justify-center rounded-md">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-blue-primary" />
    </div>
  </div>
)

const ColumnChartSection = ({ data, isLoading }) => {
  if (isLoading) {
    return (
      <div className="mt-6 rounded-md border border-tertiary-95 bg-white p-3 overflow-x-auto">
        <LoadingState />
      </div>
    )
  }

  if (data.categories.length <= 1 || data.series.length === 0) {
    return null
  }

  return (
    <div className="mt-6 rounded-md border border-tertiary-95 bg-white p-3 overflow-x-auto">
      <ColumnChart
        categories={data.categories}
        series={data.series}
        title={EVOLUCION_DENUNCIAS_CHART.title}
        ariaLabel={EVOLUCION_DENUNCIAS_CHART.ariaLabel}
        width="100%"
        height={CHART_HEIGHT}
      />
    </div>
  )
}

ColumnChartSection.propTypes = {
  data: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.string).isRequired,
    series: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.number).isRequired,
      })
    ).isRequired,
  }).isRequired,
  isLoading: PropTypes.bool,
}

export default ColumnChartSection
